import React, { useEffect, useState } from 'react'
import Tabs from 'blocks.simple/tabs/tabs'
import { AddDeviceByCode } from '../organisms/AddDeviceByCode/AddDeviceByCode-view'
import DisplaysAddVirtualDevice from '../__addVirtualDevice/displays__addVirtualDevice'
import { api } from 'core/api/ConnectionManager'
import helpers from 'core/helpers'
import translate, { getUserLocale } from 'core/translate'
import { useOnMount } from 'core/hooks'
import { getURLSearchParamsByLocation } from 'features/routes/utils'
import { useLocation } from 'react-router'
import { VirtualDeviceGroupOption } from '../__addVirtualDevice/displays__addVirtualDevice.local.methods'
import { cn } from 'ethcss'
import { grid } from 'theme'
import styles from './displays__approve.jcss'

export default () => {
    const location = useLocation()
    const query = getURLSearchParamsByLocation(location)
    const [groups, setGroups] = useState<VirtualDeviceGroupOption[]>([])
    const currentGroup = {
        id: parseInt(query.parentId, 10),
    }
    useOnMount(() => {
        api.send('getAvailableToCreateParentGroups', { nestedQ: false }, { hideLoader: true }).then(
            (availableFolders: any) => {
                const groups = helpers.addParentKeyIdForTree(availableFolders, 'parentId') as VirtualDeviceGroupOption[]
                setGroups(groups)
            }
        )
    })

    return (
        <Tabs className={cn(grid.p_md, styles.tabPanel)}>
            <AddDeviceByCode label={translate('addDeviceByCode')} tabid="add-device" />
            <DisplaysAddVirtualDevice
                label={translate('createVirtualDevice')}
                tabid="create-virtual-device"
                groups={groups}
                currentGroup={currentGroup}
            />
        </Tabs>
    )
}
